import { render, staticRenderFns } from "./ButtonLoginAzureAD.vue?vue&type=template&id=35cfdb1b&scoped=true"
import script from "./ButtonLoginAzureAD.vue?vue&type=script&lang=js"
export * from "./ButtonLoginAzureAD.vue?vue&type=script&lang=js"
import style0 from "./ButtonLoginAzureAD.vue?vue&type=style&index=0&id=35cfdb1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cfdb1b",
  null
  
)

export default component.exports